import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTWCL_We_wanted_to_check_in_to_make__ELL,
  TXTWCL_Your_Gaming_Limits
} from './PlayingLimitsReminderContent.messages.json';
import PlayingLimitsReminderContentCZ from './PlayingLimitsReminderContentCZ/PlayingLimitsReminderContentCZ';
import PlayingLimitsReminderContentNL from './PlayingLimitsReminderContentNL/PlayingLimitsReminderContentNL';
import styles from './shared.scss';

interface Props {
  embedded?: boolean;
}

const PlayingLimitsReminderContent: React.FC<Props> = ({ embedded = false }) => {
  const license = useSelector(select.account.getLicense);

  return (
    <>
      {embedded && (
        <h3>
          <Translation tagName="p" {...TXTWCL_Your_Gaming_Limits} />
        </h3>
      )}
      <Translation tagName="p" {...TXTWCL_We_wanted_to_check_in_to_make__ELL} />
      <div className={styles.menuLinks}>
        {license === LicenceId.NL && <PlayingLimitsReminderContentNL />}
        {license === LicenceId.CZ && <PlayingLimitsReminderContentCZ />}
      </div>
    </>
  );
};

export default PlayingLimitsReminderContent;
